import { Link } from 'react-router-dom';
import CallButton from '../components/CallButton';
import ChatButton from '../components/ChatButton';
import Faq from '../components/Faq';
import HelpBand from '../components/HelpBand';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import { hero, reviews, services, stats, steps, topics } from '../data';

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="wrap hero-grid">
          <div className="hero-copy">
            <p className="eyebrow">{hero.eyebrow}</p>
            <h1>{hero.title}</h1>
            <p className="hero-lead">{hero.lead}</p>
            <ul className="hero-points">
              {hero.points.map((point) => (
                <li key={point}>
                  <Icon name="check" size={16} />
                  {point}
                </li>
              ))}
            </ul>
            <div className="btn-row">
              <ChatButton size="lg" />
              <CallButton size="lg" />
            </div>
          </div>
          <LeadForm source="hero-form" />
        </div>
      </section>

      <section className="stats">
        <div className="wrap stats-grid">
          {stats.map((stat) => (
            <div key={stat.label} className="stat">
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section" id="services">
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">What we help with</p>
            <h2>Every branch of the problem, covered</h2>
            <p>From the first install to a full move to a new computer, we guide you through it one step at a time.</p>
          </div>
          <div className="card-grid">
            {services.map((service) => (
              <article key={service.title} className="card">
                <span className="card-icon">
                  <Icon name={service.icon} />
                </span>
                <h3>{service.title}</h3>
                <p>{service.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-paper" id="how-it-works">
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">How it works</p>
            <h2>Three steps back to your research</h2>
          </div>
          <ol className="steps">
            {steps.map((step, index) => (
              <li key={step.title} className="step">
                <span className="step-num">{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="wrap split">
          <div className="section-head section-head-left">
            <p className="eyebrow">Quick fixes</p>
            <h2>Popular help topics</h2>
            <p>Try these self-help guides first. If the fix does not stick, our team is one click away.</p>
            <Link to="/help-topics" className="btn btn-outline">
              Browse all topics
            </Link>
          </div>
          <ul className="topic-list">
            {topics.map((topic) => (
              <li key={topic.slug}>
                <Link to={`/help-topics#${topic.slug}`}>
                  <strong>{topic.title}</strong>
                  <span>{topic.summary}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section section-paper">
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">Kind words</p>
            <h2>What family historians tell us</h2>
          </div>
          <div className="card-grid card-grid-3">
            {reviews.map((review) => (
              <figure key={review.name} className="review">
                <blockquote>“{review.text}”</blockquote>
                <figcaption>
                  <strong>{review.name}</strong>
                  <span>{review.place}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="section" id="faq">
        <div className="wrap faq-wrap">
          <div className="section-head">
            <p className="eyebrow">FAQ</p>
            <h2>Common questions</h2>
          </div>
          <Faq />
        </div>
      </section>

      <HelpBand />
    </>
  );
}
